import { map, OperatorFunction } from 'rxjs';

/**
 * Zet een openapi-fetch resultaat ({ data, error, response }) om naar `data`,
 * en gooit bij een niet-OK response een fout zodat de RxJS-stream error't.
 *
 * Reden: de ApiService-middleware rejecteert niet bij HTTP-fouten — ze rapporteert
 * de fout (notificatie) en resolvet de promise alsnog met { data: undefined, error }.
 * Zonder deze operator zou een `tap`-success-handler (bv. optimistische lijst-mutatie
 * bij restore/delete-deep) ook bij een backend-fout draaien. Door hier te throwen
 * draait die niet en kan de aanroeper de fout centraal afvangen (catchError); de
 * notificatie is op dat moment al getoond door de middleware.
 */
export function unwrapData<T>(): OperatorFunction<any, T> {
    return map((result: { data?: unknown; error?: unknown; response?: { ok: boolean } }) => {
        if (result?.response && !result.response.ok) {
            throw result.error ?? new Error('request failed');
        }
        return result.data as T;
    });
}
